import React from "react";
import { Route, Switch } from "react-router-dom";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import AuthenticatedRoute from './components/AuthenticatedRoute';

import Home from "./pages/Home";
import Login from "./pages/Login";
import Logout from './pages/Logout';
import NotFound from "./pages/NotFound";

export default ({ childProps }) =>
  <Switch>
    <AuthenticatedRoute path="/" exact component={Home} props={childProps} />
    <AuthenticatedRoute path="/logout" exact component={Logout} props={childProps} />

    <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />
    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>;



// WEBPACK FOOTER //
// ./src/Routes.js